/* DP Editorial v18 (home): flavor switch in the hero buy box (swaps the studio photo),
   the product rail (arrows, mouse drag, progress line), the Performance Stack highlight and the finale drift.
   Quick add, toast, counters, headings, filter, label reader and quiz come from dp-premium.js. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, el) { return [].slice.call((el || document).querySelectorAll(s)); }
  function onScroll(fn) {
    var raf = 0;
    addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; fn(); }); }, { passive: true });
    fn();
  }

  /* hero buy box: the flavor changes the product photo, price, link and what "Add to cart" adds */
  function initBuy(root) {
    $$('[data-buy]', root).forEach(function (box) {
      if (box._buy) return;
      box._buy = true;
      var btns = $$('[role=radio]', box), add = box.querySelector('[data-qadd]'), price = box.querySelector('.bb-price'),
        more = box.querySelector('.bb-more'), stage = document.querySelector(box.getAttribute('data-stage'));
      function pick(b, focus) {
        btns.forEach(function (x) { var on = x === b; x.setAttribute('aria-checked', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; });
        if (add) {
          add.setAttribute('data-qadd', b.getAttribute('data-id'));
          add.setAttribute('data-title', b.getAttribute('data-title'));
          add.setAttribute('data-img', b.getAttribute('data-img'));
        }
        if (price) price.textContent = b.getAttribute('data-price');
        if (more) more.href = b.getAttribute('data-url');
        if (stage) $$('.ehero-scene', stage).forEach(function (pic) { pic.classList.toggle('on', pic.getAttribute('data-flavor') === b.getAttribute('data-flavor')); });
        if (focus) b.focus();
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { pick(b); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, n = (k === 'ArrowRight' || k === 'ArrowDown') ? i + 1 : (k === 'ArrowLeft' || k === 'ArrowUp') ? i - 1 : null;
          if (n === null) return;
          e.preventDefault();
          pick(btns[(n + btns.length) % btns.length], true);
        });
      });
    });
  }

  /* product rail: arrows, mouse drag (touch scrolls natively), keyboard, and a progress line */
  function initRail(root) {
    var rail = root.querySelector('[data-rail]');
    if (!rail || rail._rail) return;
    rail._rail = true;
    var sec = rail.closest('section'), prev = sec.querySelector('[data-rail-prev]'), next = sec.querySelector('[data-rail-next]'), bar = sec.querySelector('[data-rail-bar]');
    function stepSize() {
      var c = rail.querySelector('.pcard:not(.gone)');
      if (!c) return rail.clientWidth * 0.8;
      var w = c.getBoundingClientRect().width + 16;
      return w * Math.max(1, Math.floor((rail.clientWidth - 40) / w));
    }
    function paint() {
      var max = rail.scrollWidth - rail.clientWidth, f = max > 0 ? rail.scrollLeft / max : 0, w = rail.scrollWidth ? Math.min(1, rail.clientWidth / rail.scrollWidth) : 1;
      if (bar) { bar.style.width = (w * 100).toFixed(2) + '%'; bar.style.transform = 'translateX(' + (f * (1 / w - 1) * 100).toFixed(2) + '%)'; }
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > max - 4;
    }
    var raf = 0;
    rail.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; paint(); }); }, { passive: true });
    addEventListener('resize', paint);
    function go(dir) { rail.scrollBy({ left: dir * stepSize(), behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    rail.addEventListener('keydown', function (e) {
      if (e.target !== rail) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    /* a new filter starts the rail from the beginning */
    $$('[data-ltabs] button', sec).forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(function () { rail.scrollTo({ left: 0 }); paint(); }, 280); });
    });
    var down = false, moved = false, sx = 0, sl = 0;
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button')) return;
      down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft;
    });
    addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 6) { moved = true; rail.classList.add('dragging'); }
      if (moved) rail.scrollLeft = sl - dx;
    });
    addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) { rail.classList.remove('dragging'); setTimeout(function () { moved = false; }, 0); }
    });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    paint();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(paint);
  }

  /* Performance Stack: pointing at a step keeps that product in the light and veils the other two */
  function initStack(root) {
    var slab = root.querySelector('[data-slab]');
    if (!slab) return;
    var rows = $$('.routine [data-hl]', root);
    function set(k) {
      if (k) slab.setAttribute('data-active', k); else slab.removeAttribute('data-active');
      rows.forEach(function (r) { r.classList.toggle('on', r.getAttribute('data-hl') === k); });
    }
    rows.forEach(function (r) {
      r.tabIndex = 0;
      r.addEventListener('mouseenter', function () { set(r.getAttribute('data-hl')); });
      r.addEventListener('mouseleave', function () { set(null); });
      r.addEventListener('focus', function () { set(r.getAttribute('data-hl')); });
      r.addEventListener('blur', function () { set(null); });
    });
  }

  /* finale: the room drifts gently while it passes */
  function initFinal(root) {
    var f = root.querySelector('.efinal'), img = f && f.querySelector('.efinal-bg');
    if (!img || reduce) return;
    onScroll(function () {
      var r = f.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      var p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      img.style.transform = 'scale(1.08) translate3d(0,' + (p * -46).toFixed(1) + 'px,0)';
    });
  }

  function init(root) {
    if (!root) return;
    initBuy(root);
    initRail(root);
    initStack(root);
    initFinal(root);
  }
  function boot() { init(document.querySelector('.dpc-home.dpe')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.dpc-home.dpe')); });
})();
